// TRACK EVENTS
export const APP_LOGIN = 'APP_LOGIN';
export const CHANGE_INBOX_PAGE = 'CHANGE_INBOX_PAGE';
export const DOWNLOAD_INBOX_CSV = 'DOWNLOAD_INBOX_CSV';
export const OPEN_PROFILE_MENU = 'OPEN_PROFILE_MENU';
export const DOWNLOAD_ANALYTICS_CSV = 'DOWNLOAD_ANALYTICS_CSV';
export const TOGGLE_ANALYTICS_CHART_LEGEND = 'TOGGLE_ANALYTICS_CHART_LEGEND';
export const SHOW_ANALYTICS_TOOLTIP = 'SHOW_ANALYTICS_TOOLTIP';
export const VIEW_OPPORTUNITIES_TAB_ANALYTICS = 'VIEW_OPPORTUNITIES_TAB_ANALYTICS';
export const VIEW_ACCOUNTS_TAB_ANALYTICS = 'VIEW_ACCOUNTS_TAB_ANALYTICS';
export const VIEW_CAMPAIGNS_TAB_ANALYTICS = 'VIEW_CAMPAIGNS_TAB_ANALYTICS';
export const VIEW_MANAGERS_TAB_ANALYTICS = 'VIEW_MANAGERS_TAB_ANALYTICS';
export const VIEW_SEQUENCES_TAB_ANALYTICS = 'VIEW_SEQUENCES_TAB_ANALYTICS';
export const VIEW_TEMPLATES_TAB_ANALYTICS = 'VIEW_TEMPLATES_TAB_ANALYTICS';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const DESTROY_ACCOUNT = 'DESTROY_ACCOUNT';
export const CREATE_ACCOUNT_BLACKLISTED_CONTACTS = 'CREATE_ACCOUNT_BLACKLISTED_CONTACTS';
export const CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS = 'CREATE_BULK_ACCOUNT_BLACKLISTED_CONTACTS';
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const CREATE_SEQUENCE = 'CREATE_SEQUENCE';
export const UPDATE_SEQUENCE = 'UPDATE_SEQUENCE';
export const GET_ACCOUNT_CONTACTS = 'GET_ACCOUNT_CONTACTS';
export const DELETE_EMAIL_CONFIG_EVENT = 'DELETE_EMAIL_CONFIG';
export const ADD_EMAIL_CONFIG_EVENT = 'ADD_EMAIL_CONFIG';
export const REMOVE_EMAIL_CONFIG_EVENT = 'REMOVE_EMAIL_CONFIG';
export const CREATE_IMAP_SMTP_CONFIG = 'CREATE_IMAP_SMTP_CONFIG';
export const UPDATE_IMAP_SMTP_CONFIG = 'UPDATE_IMAP_SMTP_CONFIG';
export const CREATE_EMAIL_KNOWN_CONFIG = 'CREATE_EMAIL_OUTLOOK_CONFIG';
export const UPDATE_EMAIL_KNOWN_CONFIG = 'UPDATE_EMAIL_OUTLOOK_CONFIG';
export const CREATE_GOOGLE_OAUTH_CONFIG = 'CREATE_GOOGLE_OAUTH_CONFIG';
export const UPDATE_GOOGLE_OAUTH_CONFIG = 'UPDATE_GOOGLE_OAUTH_CONFIG';
export const CREATE_MICROSOFT_OAUTH_CONFIG = 'CREATE_MICROSOFT_OAUTH_CONFIG';
export const UPDATE_MICROSOFT_OAUTH_CONFIG = 'UPDATE_MICROSOFT_OAUTH_CONFIG';
export const CREATE_MESSAGE = 'CREATE_MESSAGE';
export const CREATE_REPLY_MESSAGE = 'CREATE_REPLY_MESSAGE';
export const CREATE_REPLY_ALL_MESSAGE = 'CREATE_REPLY_ALL_MESSAGE';
export const CREATE_FORWARD_MESSAGE = 'CREATE_FORWARD_MESSAGE';
export const CATEGORIZE_EMAIL = 'CATEGORIZE_EMAIL';
export const CATEGORIZE_EMAIL_BULK = 'CATEGORIZE_EMAIL_BULK';
export const GET_ANALYTICS = 'GET_ANALYTICS';
export const MOVE_BULK_SEQUENCE_CONTACT = 'MOVE_BULK_SEQUENCE_CONTACT';
export const REMOVE_FROM_CAMPAIGN = 'REMOVE_FROM_CAMPAIGN';
export const REMOVE_BULK_FROM_CAMPAIGN = 'REMOVE_BULK_FROM_CAMPAIGN';
export const MARK_AS_FINISHED = 'MARK_AS_FINISHED';
export const BULK_MARK_AS_FINISHED = 'BULK_MARK_AS_FINISHED';
export const UNMARK_AS_FINISHED = 'UNMARK_AS_FINISHED';
export const BULK_UNMARK_AS_FINISHED = 'BULK_UNMARK_AS_FINISHED';
export const DESTROY_SEQUENCE_CONTACTS = 'DESTROY_SEQUENCE_CONTACTS';
export const DESTROY_SEQUENCE_CONTACT = 'DESTROY_SEQUENCE_CONTACT';
export const GET_SEQUENCE_CONTACTS = 'GET_SEQUENCE_CONTACTS';
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const PERSONAL_ACCOUNT_UPDATE = 'ACCOUNT_UPDATE';
export const PERSONAL_ACCOUNT_EMAIL_UPDATE = 'ACCOUNT_EMAIL_UPDATE';
export const PERSONAL_ACCOUNT_PASSWORD_UPDATE = 'ACCOUNT_PASSWORD_UPDATE';
export const PAGES_TRACK = [
  /^\/campaigns$/,
  /^\/accounts$/,
  /^\/reports$/,
  /^\/reports\/\w+$/,
  /^\/dashboard$/,
  /^\/dashboard\/\w+$/,
  /^\/myaccount$/,
  /^\/inbox$/,
  /^\/login$/,
  /^\/404$/,
];

export const CREATE_MESSAGE_MAP = { CREATE_REPLY_MESSAGE, CREATE_REPLY_ALL_MESSAGE, CREATE_FORWARD_MESSAGE };
export const getCreateMessageEvent = type => CREATE_MESSAGE_MAP[`CREATE_${type}_MESSAGE`] || CREATE_MESSAGE;
export const GET_MENTIONS = 'GET_MENTIONS';
export const CREATE_MENTION = 'CREATE_MENTION';
export const EDIT_MENTION = 'EDIT_MENTION';

export const GET_OPPORTUNITIES = 'GET_OPPORTUNITIES';
export const GET_OPPORTUNITY = 'GET_OPPORTUNITY';
export const CREATE_OPPORTUNITY = 'CREATE_OPPORTUNITY';
export const UPDATE_OPPORTUNITY = 'UPDATE_OPPORTUNITY';
export const PATCH_OPPORTUNITY = 'PATCH_OPPORTUNITY';
